import { accountActionTypes as actionType } from 'src/constants/actionTypes';
import accountService from 'src/services/accountService';
import authService from 'src/services/authService';
import passwordService from 'src/services/passwordService';
import dispatchError from 'src/utils/dispatchError';

export function loadUser() {
  return async (dispatch) => {
    try {
      const user = await accountService.loadUser();
      dispatch({
        type: actionType.LOAD_USER,
        payload: {
          auth: authService.isAuthenticated(),
          user
        }
      });
    } catch (error) {
      dispatchError(dispatch, error, actionType.ACCOUNT_FAILURE, 'Failed to load current user');
    }
  };
}

export function login(username, password) {
  return async (dispatch) => {
    try {
      const tokenObj = await accountService.login(username, password);
      authService.setSession(tokenObj);
      if (tokenObj.accessType !== 'MFA') {
        dispatch({
          type: actionType.ACCOUNT_SUCCESS,
          payload: {
            auth: !!tokenObj,
          }
        });
        dispatch(loadUser());
      } else {
        dispatch({
          type: actionType.NEED_SMS,
          payload: {
            auth: !!tokenObj,
          }
        });
      }
    } catch (error) {
      authService.setSession(null);
      dispatchError(dispatch, error, actionType.ACCOUNT_FAILURE, 'Login failed');
    }
  };
}

export function authenticate(code) {
  return async (dispatch) => {
    try {
      const tokenObj = await accountService.authenticate(code);
      authService.setSession(tokenObj);
      dispatch({
        type: actionType.ACCOUNT_SUCCESS,
        payload: {
          auth: !!tokenObj,
        }
      });
      dispatch(loadUser());
    } catch (error) {
      dispatchError(dispatch, error, actionType.ACCOUNT_FAILURE, 'Authenticate failed');
    }
  };
}

export function loginWithToken(token) {
  return async (dispatch) => {
    try {
      const tokenObj = await accountService.loginWithToken(token);
      authService.setSession(tokenObj);
      dispatch({
        type: actionType.ACCOUNT_SUCCESS,
        payload: {
          auth: !!tokenObj,
        }
      });
      dispatch(loadUser());
    } catch (error) {
      authService.setSession(null);
      dispatchError(dispatch, error, actionType.ACCOUNT_FAILURE, 'Login failed');
    }
  };
}

export function loginWithSsoToken(token) {
  return async (dispatch) => {
    try {
      const tokenObj = await accountService.loginWithSsoToken(token);
      authService.setSession(tokenObj);
      dispatch({
        type: actionType.ACCOUNT_SUCCESS,
        payload: {
          auth: !!tokenObj,
        }
      });
      dispatch(loadUser());
    } catch (error) {
      authService.setSession(null);
      dispatchError(dispatch, error, actionType.ACCOUNT_FAILURE, 'Login failed');
    }
  };
}

export function logout() {
  return async (dispatch) => {
    // Avoid making /revoke API call if there is no active session
    if (authService.isAuthenticated()) {
      await accountService.logout();
    }
    authService.setSession(null);
    dispatch({ type: actionType.LOGOUT });
  };
}

export function changePassword(username, currentPassword, newPassword) {
  return async (dispatch) => {
    try {
      await passwordService.changePassword(username, currentPassword, newPassword);
      dispatch({
        type: actionType.CHANGE_PASSWORD,
        payload: {
          auth: authService.isAuthenticated(),
        }
      });
    } catch (error) {
      dispatchError(dispatch, error, actionType.ACCOUNT_FAILURE, 'Failed to change password');
    }
  };
}

export function sendResetPasswordEmail(username) {
  return async (dispatch) => {
    const msg = 'If a valid username was entered, an email with reset<br />'
      + 'instructions has been sent to the associated account.';
    try {
      await passwordService.sendResetPasswordEmail(username);
    } catch (error) {
      // Same message on success and failure so devious people can't find
      // the difference
    }
    dispatch({
      type: actionType.ACCOUNT_SUCCESS,
      payload: {
        auth: false,
        message: msg
      }
    });
  };
}

export function resetForgottenPassword(username, newPassword, emailToken) {
  return async (dispatch) => {
    try {
      await passwordService.resetForgottenPassword(username, newPassword, emailToken);
      dispatch(login(username, newPassword));
    } catch (error) {
      dispatchError(dispatch, error, actionType.ACCOUNT_FAILURE, 'Failed to change password');
    }
  };
}

export const setStatus = (status) => ({
  type: actionType.SET_STATUS,
  payload: { status }
});

export const setError = (error) => ({
  type: actionType.SET_ERROR,
  payload: { error }
});
